import React, { useCallback } from 'react';

import { selectFaqQuestion, selectOneChatSettings } from '@/features';
import { useAppDispatch, useAppSelector } from '@/store';

import { TextOption } from '../ChatMessage/VisitorOptions/FieldOptions/TextOption';

import { st, classes } from './FaqQuestionPayload.st.css';

export const FaqQuestionPayload = ({
  id,
  title,
}: {
  id?: string;
  title?: string;
}) => {
  const dispatch = useAppDispatch();
  const isAwaitingAnswer = useAppSelector(
    (state) => state.messages.awaitingAnswer,
  );
  const isManual = useAppSelector(selectOneChatSettings.isManual);

  const onSubmit = useCallback(() => {
    if (id && title?.trim().length && !isAwaitingAnswer && isManual) {
      dispatch(selectFaqQuestion({ id, question: title }));
    }
  }, [dispatch, id, title, isAwaitingAnswer, isManual]);

  if (!title) {
    return null;
  }

  return (
    <TextOption
      className={st(classes.root)}
      text={title}
      onClick={onSubmit}
      disabled={isAwaitingAnswer || !isManual}
    />
  );
};
